import { render } from "./BoleteriaScanner.vue?vue&type=template&id=5471047c&scoped=true"
import script from "./BoleteriaScanner.vue?vue&type=script&lang=js"
export * from "./BoleteriaScanner.vue?vue&type=script&lang=js"

import "./BoleteriaScanner.vue?vue&type=style&index=0&id=5471047c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5471047c"]])

export default __exports__